import * as React from 'react';
import { Link, PathMatch } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { getAbsoluteUrl } from 'Douleutaras/utilities/url-builder';
import classNames from 'classnames';

import './ChatButton.scss';

interface ChatButtonProps {
  onlyIcon: boolean;
  isChatRoute: PathMatch<string>;
  messagesCount: number;
}

export const ChatButton = ({ onlyIcon, messagesCount, isChatRoute}: ChatButtonProps) => {
  const { t } = useTranslation();

  return (
    <div styleName="header-chat" data-user={onlyIcon ? 'pro' : 'customer'}>
      <div styleName={classNames({
        'header-chat__inner': true,
        'header-chat__inner--active': isChatRoute
      })}>
        <span styleName="header-chat__icon" className="dashicon dashicon-chat-bubble-outline"/>
        <span styleName="header-chat__title">
          {t('T.HEADER.MY-MESSAGES')}
        </span>
        {messagesCount > 0 &&
          <span styleName="header-chat__count">
            {
              messagesCount < 100 ? messagesCount : '99+'
            }
          </span>
        }
        <Link
          to={onlyIcon ? getAbsoluteUrl('PRO_DASHBOARD.CONVERSATION.INDEX') : getAbsoluteUrl('CLIENT_DASHBOARD.CONVERSATION.INDEX')}
          data-tracking={onlyIcon ? 'pro-dashboard-navbar__chat' : ''}
          styleName="header-chat__link" />
      </div>
    </div>
  );
};

export default ChatButton;
